import React, { Component } from 'react'
import { connect } from 'react-redux'
import { callLogin } from '../actions/Auth'
import Loader from './Loader'
import { Redirect } from 'react-router-dom'

const initialState = {
  email: '',
  password: ''
}

class Login extends Component {
  constructor() {
    super()
    this.state = initialState
  }
  tryLogin(event) {
    if (event.key === 'Enter') {
      this.login()
    }
  }
  login() {
    let valid = true
    if (this.state.email === '') {
      valid = false
    }
    if (this.state.password === '') {
      valid = false
    }
    if (valid) {
      this.props.callLogin({
        email: this.state.email,
        password: this.state.password
      })
    }
  }
  render() {
    const { loading, error, valid } = this.props.auth
    return (
      <div className='container'>
        <div className='inside centralize'>
          <h1>Accedi</h1>
          <ul className='ul-login'>
            <li>
              <label>
                <input
                  type='email'
                  placeholder='Email'
                  onChange={(event) =>
                    this.setState({ email: event.target.value })
                  }
                  onKeyPress={(event) => this.tryLogin(event)}
                  value={this.state.email}
                />
              </label>
            </li>
            <li>
              <label>
                <input
                  type='password'
                  placeholder='Password'
                  onChange={(event) =>
                    this.setState({ password: event.target.value })
                  }
                  onKeyPress={(event) => this.tryLogin(event)}
                  value={this.state.password}
                />
              </label>
            </li>
            <li>
              <button className='lnk-login' onClick={(e) => this.login()}>
                {loading && <Loader />}
                {!loading && <span>Accedi</span>}
              </button>
            </li>
          </ul>
          <div className='log-response'>
            {error !== null && <span>{error}</span>}
          </div>
          {valid && <Redirect to='/dashboard' />}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { callLogin })(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js